// Generated by `bazel run i18n`. Do not edit by hand.
import en from "./en/merchant-fulfillment-app.json";

export default en;
